import SubdirectoryIcon from '@/assets/icons/icon-subdirectory.svg'
import { TooltipWithHoverList } from '@/components/ui/table/components/tooltip-with-hover-list.tsx'
import type { MediaOption } from '@/modules/message/components/editor/fields/message-media-dropdown.tsx'
import type { Message } from '@/modules/online-mass-messages/types.ts'

export const TooltipWithList = ({
  messages,
  followUpMessages,
  mediaOptions,
}: {
  messages: Message[]
  followUpMessages?: Message[]
  mediaOptions: MediaOption[]
}) => {
  return (
    <div className="flex flex-col items-start gap-1">
      <TooltipWithHoverList
        messages={messages}
        mediaOptions={mediaOptions}
      />
      {!!followUpMessages?.length && (
        <div className="flex items-center gap-1">
          <SubdirectoryIcon />
          <TooltipWithHoverList
            messages={followUpMessages}
            mediaOptions={mediaOptions}
          />
        </div>
      )}
    </div>
  )
}
